import { BaseInput } from '../shared/base-input';

export function FooterFilter({
  useContextFn,
  placeHolder,
  label,
  errorMessages = {},
}: {
  useContextFn: () => {
    footer: string;
    setFooter: (value: string) => void;
  };
  label?: string;
  placeHolder?: string;
  errorMessages?: Record<string, string>;
}) {
  const { footer: value, setFooter: onChange } = useContextFn();
  const helperText = errorMessages['footer'];
  return (
    <BaseInput
      label={label ?? 'Footer'}
      placeHolder={placeHolder ?? 'Footer'}
      q={value}
      writeQ={onChange}
      type="text"
      multiline
      rows={3}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
